
define(
	'MHI.MHISidebarProfile.Main'
,   [
		'Header.Menu.View',
		'Header.Profile.View'
	]
,   function (
		HeaderMenuView,
		HeaderProfileView
	)
{
	'use strict';

	// The mobile hamburger menu (Header.Menu) renders the "header_sidebar"
	// template, which contains a
	//   <div class="header-sidebar-profile-menu" data-view="Header.Profile"></div>
	// placeholder for the Login / Register (or My Account) links. On this
	// storefront that placeholder is left empty on render, so the Login button
	// never appears on mobile. (The desktop copy in .header-menu-profile renders
	// fine but is hidden on mobile.)
	//
	// We re-render a Header.Profile.View into the sidebar placeholder after the
	// menu renders, but only when core left it empty, so we never fight with a
	// version/theme that already fills it.
	return  {
		mountToApp: function mountToApp (container)
		{
			HeaderMenuView.prototype.render = _.wrap( HeaderMenuView.prototype.render, function (fn) {
				var result = fn.apply(this, _.toArray(arguments).slice(1));

				var $placeholder = this.$('.header-sidebar-profile-menu');

				if ( $placeholder.length && !$placeholder.children().length ) {
					if ( this.sidebarProfileView ) {
						this.sidebarProfileView.destroy();
					}

					this.sidebarProfileView = new HeaderProfileView({
						showMyAccountMenu: false
					,	application: this.application
					});

					this.sidebarProfileView.setElement($placeholder).render();
				}

				return result;
			});
		}
	};
});
